import { detectionCategory } from 'json/lab-order'
export let filterFactor = [ {
  label: '类型',
  type: 'select',
  clearable: true,
  value: 'category', // 需返回数据的字段名
  options: getTypes()
}]
export let tableLabels = [{
  label: '样本编号',
  value: 'sampleId'
}, {
  label: '姓名',
  value: 'fullName'
}, {
  label: '性别',
  value: 'gender'
}, {
  label: '年龄',
  value: 'age'
}, {
  label: '样本类型',
  value: 'sample'
}]
function getTypes () {
  let options = []
  detectionCategory.forEach(item => {
    let signalItem = {
      label: item.value,
      value: item.key
    }
    options.push(signalItem)
  })
  return options
}
